export default __webpack_public_path__ + "static/media/bg2_mob_.457c6c16.png";